<template>
  <!-- Modal -->
  <div>
    <div class="modal fade" id="ArchiveOrdersModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">{{translations('common.addition')}}</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>{{translations('order.quotation_data')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <tr>
                  <td>
                    <v-select class="v-select-wd100" :options="orderList" label="name" value="id" v-model="selectedOrder"></v-select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
          </div>
          <div class="modal-footer justify-content-between">
            <div>
              <a class="btn btn-link decoration-underline" href="/new-orders">{{translations('order.to_new_registration')}}</a>
            </div>
            <div>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>&nbsp;
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                @click="addToEstimate()"
                :disabled="isDisable"
              >{{translations('common.update')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveOrdersModal',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      orderList: [],
      selectedOrder: null,
      isSearching: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    isDisable () {
      return !this.selectedOrder
    }
  },
  mounted () {
    const self = this
    window.$('#ArchiveOrdersModal').one('shown.bs.modal', function () {
      self.getOrderData().catch(function (error) {
        self.$toastr.error(error, this.translations('common.error'))
      })
    })
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getOrderData () {
      const self = this
      return this.$http.post(this.$api_url.orders_get_estimate).then(response => {
        const result = response.data
        if (result.status === true) {
          self.orderList = result.list
          return Promise.resolve()
        } else {
          return Promise.reject(new Error(result.message))
        }
      }).catch(function (error) {
        console.log('ArchiveOrdersModal:getOrderData:catch(error): ', error)
        return Promise.reject(new Error(this.translations('order.notice_failed')))
      })
    },

    addToEstimate () {
      this.isSearching = true

      const params = {
        estimate_id: this.selectedOrder.id
      }

      const self = this
      this.$http.post(this.$api_url.add_from_estimate, params).then(response => {
        const result = response.data
        if (result.status === true) {
          self.$toastr.success(this.translations('order.notice_order_has_added'), this.translations('common.success'))
          self.$emit('add')
        } else {
          self.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(function (error) {
        console.log('ArchiveOrdersModal:addToEstimate:catch(error): ', error)
        self.$toastr.error(this.translations('order.notice_failed'), this.translations('common.error'))
      }).finally(function () {
        self.isSearching = false
        self.selectedOrder = null
      })
    }
  }
}
</script>
